export const LoggedInRoutes = {
  CLUSTERS: {
    INDEX: "/",
    SHOW: uuid => `/clusters/show/${uuid}/overview`,
    NODES: uuid => `/clusters/show/${uuid}/nodes`,
    TAPS: uuid => `/clusters/show/${uuid}/taps`,
    HEALTH: uuid => `/clusters/show/${uuid}/health`,
    SUPPORT: uuid => `/clusters/show/${uuid}/support`,
    APIKEY: uuid => `/clusters/show/${uuid}/apikey`,
    DATA: {
      OUIS: uuid => `/clusters/show/${uuid}/data/ouis`,
      BLUETOOTH: uuid => `/clusters/show/${uuid}/data/bluetooth`,
      GEOIP: uuid => `/clusters/show/${uuid}/data/geoip`,
      UAV: uuid => `/clusters/show/${uuid}/data/uav`,
      ENVIRONMENT: uuid => `/clusters/show/${uuid}/data/environment`,
    },
    SETTINGS: {
      INDEX: uuid => `/clusters/${uuid}/settings`
    },
    MGMT: {
      CREATE: "/clusters/new",
    }
  },
  USER: {
    SETTINGS: "/user/settings"
  }
}
// Extracts the cluster UUID from the path of a cluster page. Returns null for all other pages.
export const clusterIdFromPath = (pathname) => {
  const match = pathname.match(/^\/clusters\/(?:show\/)?([0-9a-fA-F-]{36})(?:\/|$)/);
  return match ? match[1] : null;
}
